function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.3144 21.9144C17.6163 21.9144 21.9144 17.6163 21.9144 12.3144C21.9144 7.01242 17.6163 2.71436 12.3144 2.71436C7.01242 2.71436 2.71436 7.01242 2.71436 12.3144C2.71436 17.6163 7.01242 21.9144 12.3144 21.9144ZM16.7629 10.7629C17.2315 10.2943 17.2315 9.53446 16.7629 9.06583C16.2943 8.5972 15.5345 8.5972 15.0658 9.06583L11.1144 13.0173L9.56288 11.4658C9.09425 10.9972 8.33446 10.9972 7.86583 11.4658C7.3972 11.9345 7.3972 12.6943 7.86583 13.1629L10.2658 15.5629C10.7345 16.0315 11.4943 16.0315 11.9629 15.5629L16.7629 10.7629Z",
  fill: "#24252B"
});

function SvgCheckCircleFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFill);
export default __webpack_public_path__ + "static/media/check-circle-fill.169afb55.svg";
export { ForwardRef as ReactComponent };